module.exports = "/_next/static/images/game-3-fingerprint-part-3-wrong-1348bc97af98e05cd41b937029f7070e.png";